//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
import "../no/ugmath.js";
import "../no/Diagramming.js";
let d=[[],[[["point"],"SetSymbolLocation",{},1,0],[["pageObject","symbolVariantName"],"CreateDiagramNode",{R_:{nodeObject:"Diagramming.Node"}},2,0],[["objTag"],"SetReferenceObject",{},1,0],[["pageObject","updatedSymbolVariantName"],"UpdateDiagramNode",{R_:{nodeObject:"Diagramming.Node"}},2,0],[["drawingStandard"],"SetDrawingStandard",{},1,0]],[]];
SPLM.AME.DiagramNodeBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.DiagramNodeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;